import { cryptos, stocks } from '../../fixtures/assets';

export const assetList: { [code: string]: string } = stocks.concat(cryptos).reduce(
  (list: any, { code, name }) => {
    list[code] = name;
    return list;
  },
  {}
);
